import { forwardRef } from "react";

export const PaperPlane = forwardRef(({ className = "", fill = "#C9A84C", ...props }, ref) => (
  <svg ref={ref} viewBox="0 0 32 32" className={className} fill={fill} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M30 3L2 14l10 4 3 11 5-7 8 5z" opacity="0.95" />
    <path d="M12 18L30 3 15 22z" fill="#0D0D0D" opacity="0.25" />
  </svg>
));
PaperPlane.displayName = "PaperPlane";

export const PaperPlaneOutline = ({ className = "", stroke = "#C9A84C", ...props }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M30 3L2 14l10 4 3 11 5-7 8 5z" />
    <path d="M12 18L30 3" />
  </svg>
);

export default PaperPlane;
